export let hrms1axColumns = () => {
  let indexColumns = [{
    key: 'codempid',
    name: '',
    labelCodapp: 'HRMS1AXC1',
    labelIndex: '60',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'desc_codempid',
    name: '',
    labelCodapp: 'HRMS1AXC1',
    labelIndex: '70',
    style: 'min-width: 200px;'
  }, {
    key: 'desc_codpos',
    name: '',
    labelCodapp: 'HRMS1AXC1',
    labelIndex: '80',
    style: 'min-width: 150px;'
  }, {
    key: 'desc_codcomp',
    name: '',
    labelCodapp: 'HRMS1AXC1',
    labelIndex: '90',
    style: 'min-width: 200px;'
  }, {
    key: 'dtework',
    name: '',
    labelCodapp: 'HRMS1AXC1',
    labelIndex: '100',
    class: 'align-center',
    style: 'min-width: 120px;',
    dataType: 'date'
  }, {
    key: 'typwork',
    name: '',
    labelCodapp: 'HRMS1AXC1',
    labelIndex: '110',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'codshift',
    name: '',
    labelCodapp: 'HRMS1AXC1',
    labelIndex: '120',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'Start',
    name: '',
    labelCodapp: 'HRMS1AXC1',
    labelIndex: '130',
    class: 'align-center',
    style: 'min-width: 160px;',
    headerRow: 1,
    colspan: 2,
    rowspan: 1
  }, {
    key: 'timbstr',
    name: '',
    labelCodapp: 'HRMS1AXC1',
    labelIndex: '140',
    class: 'align-center',
    style: 'min-width: 80px;',
    headerRow: 2,
    colspan: 1,
    rowspan: 1
  }, {
    key: 'timbend',
    name: '',
    labelCodapp: 'HRMS1AXC1',
    labelIndex: '150',
    class: 'align-center',
    style: 'min-width: 80px;',
    headerRow: 2,
    colspan: 1,
    rowspan: 1
  }, {
    key: 'End',
    name: '',
    labelCodapp: 'HRMS1AXC1',
    labelIndex: '160',
    class: 'align-center',
    style: 'min-width: 160px;',
    headerRow: 1,
    colspan: 2,
    rowspan: 1
  }, {
    key: 'timdstr',
    name: '',
    labelCodapp: 'HRMS1AXC1',
    labelIndex: '170',
    class: 'align-center',
    style: 'min-width: 80px;',
    headerRow: 2,
    colspan: 1,
    rowspan: 1
  }, {
    key: 'timdend',
    name: '',
    labelCodapp: 'HRMS1AXC1',
    labelIndex: '180',
    class: 'align-center',
    style: 'min-width: 80px;',
    headerRow: 2,
    colspan: 1,
    rowspan: 1
  }, {
    key: 'codcust',
    name: '',
    labelCodapp: 'HRMS1AXC1',
    labelIndex: '185',
    style: 'min-width: 100px;'
  }, {
    key: 'location',
    name: '',
    labelCodapp: 'HRMS1AXC1',
    labelIndex: '190',
    style: 'min-width: 200px;'
  }, {
    key: 'desc_codreason',
    name: '',
    labelCodapp: 'HRMS1AXC1',
    labelIndex: '205',
    style: 'min-width: 200px;'
  }, {
    key: 'coordinates',
    name: '',
    labelCodapp: 'HRMS1AXC1',
    labelIndex: '200',
    style: 'min-width: 200px;'
  }, {
    key: 'filenamei',
    name: '',
    labelCodapp: 'HRMS1AXC1',
    labelIndex: '210',
    style: 'min-width: 100px;',
    tagType: 'image'
  }, {
    key: 'filenameo',
    name: '',
    labelCodapp: 'HRMS1AXC1',
    labelIndex: '220',
    style: 'min-width: 100px;',
    tagType: 'image'
  }]

  return {
    en: {
      index: indexColumns
    },
    th: {
      index: indexColumns
    }
  }
}

export let hrms1axMaxRowspan = {
  index: 2
}



// WEBPACK FOOTER //
// ./src/assets/columns/hrms1ax.js